/*
 * @Author: Czy
 * @Date: 2024-09-19 18:29:18
 * @FilePath: /bikecat/src/store/search.ts
 *
 */
import { defineStore } from 'pinia'
import { ref, computed, Ref } from 'vue'
import { PosCityList } from '@/service/home/home.d'
import dayjs from 'dayjs'

export const useSearchStore = defineStore(
  'search',
  () => {
    // 酒店城市
    const hotelHistoryCity = ref<Partial<PosCityList[]>>([])
    const hotelCityInfo = ref<Partial<PosCityList>>({
      regionCode: '597',
      regionName: '北京',
      superiorRegions: '',
    })
    const trimKeyword = ref<string>('')
    const isHotelCityNull = ref<boolean>(false)
    const hotelGuestObj = ref<
      Array<{
        adultNum: number
        kidAgeList: number[]
      }>
    >([
      {
        adultNum: 1,
        kidAgeList: [],
      },
    ])
    const updateHotelHistory = (item: PosCityList) => {
      updateHistoryCity(item, hotelHistoryCity)
    }

    const updateHistoryCity = (cityInfo: PosCityList, data: Ref<Partial<PosCityList[]>>) => {
      const currentIndex = data.value.findIndex((item) => item.regionName === cityInfo.regionName)
      if (currentIndex === -1) {
        data.value.unshift(cityInfo)

        if (data.value.length > 6) {
          data.value.pop()
        }
      } else {
        // 已存在的换位置
        data.value.splice(currentIndex, 1)
        data.value.unshift(cityInfo)
      }
    }
    const resetHotelCityInfo = () => {
      hotelCityInfo.value = {
        regionCode: '597',
        regionName: '北京',
      }
    }

    const hotelDateRange = ref({
      arrivalDate: dayjs().format('YYYY-MM-DD'),
      departureDate: dayjs().add(1, 'day').format('YYYY-MM-DD'),
    })
    const setHotelDateRange = (val: { arrivalDate: string; departureDate: string }) => {
      Object.assign(hotelDateRange.value, val)
    }

    // 计算总旅客数和客房数
    const totalGuests = computed(() => {
      if (!hotelGuestObj.value || hotelGuestObj.value.length === 0) return 1
      return hotelGuestObj.value.reduce(
        (total, room) => total + room.adultNum + (room.kidAgeList?.length || 0),
        0,
      )
    })

    const totalRooms = computed(() => {
      if (!hotelGuestObj.value || hotelGuestObj.value.length === 0) return 1
      return hotelGuestObj.value.length
    })

    return {
      // cityInfo,
      hotelHistoryCity,
      hotelCityInfo,
      updateHotelHistory,
      hotelDateRange,
      setHotelDateRange,
      resetHotelCityInfo,
      isHotelCityNull,
      trimKeyword,
      hotelGuestObj,
      totalGuests,
      totalRooms,
      // hideCityAdCodeList,
      // hideCityCityCodeList,
    }
  },
  {
    persist: false,
  },
)
